import { Season } from 'types/seasons';

import SeasonDetails from 'components/shared/Spaces/SeasonDetails';

import { Conditional } from '../../Checkout/program/step/lib/application.util';
import SubTitle from 'components/shared/Title/SubTitle';
import { css } from '@emotion/react';

const sectionCss = css`
	margin-bottom: 50px;
	margin-top: 11px;
`;

const gridCss = css`
	display: flex;
	flex-wrap: wrap;
	gap: 2rem;
`;

const gridChildCss = css`
	width: 280px;
`;

interface Props {
	programSeasons: Season[];
	type: string;
}

const ProgramSeasons = ({ programSeasons, type }: Props) => {
	return (
		<Conditional show={programSeasons.length !== 0}>
			<div css={sectionCss}>
				<SubTitle text={type} />

				<div css={gridCss}>
					{programSeasons.map(seasonItem => (
						<div css={gridChildCss} key={seasonItem.id}>
							<SeasonDetails key={seasonItem.id} {...seasonItem} />
						</div>
					))}
				</div>
			</div>
		</Conditional>
	);
};

export default ProgramSeasons;
